import { useNavigate } from 'react-router'

import { useSound } from '../sound/sound-context.js'

/**
 * Escape backs out one step, and out of the game when there is nothing left to
 * back out of.
 *
 * Each game already used Escape to clear what she had typed or taken, so this
 * keeps that meaning and adds the last rung: with nothing part-done, Escape
 * leaves. That makes one key mean "undo my way out of here" everywhere, which
 * is a thing worth being able to guess.
 *
 * Nothing is lost by leaving. The round was never spent, so the server will
 * happily deal it again — she has abandoned a word, not thrown away a result.
 */
export function useLeaveOnEscape(): (hasSomethingToClear: boolean) => boolean {
  const navigate = useNavigate()
  const sound = useSound()

  return (hasSomethingToClear: boolean) => {
    if (hasSomethingToClear) return false

    /*
     * Cued here rather than in each of the six games, because this is the one
     * place leaving actually happens — and the rung above it, where Escape
     * clears something instead, is deliberately silent: that is undoing, not
     * going.
     */
    sound.play('back')
    void navigate('/')
    return true
  }
}
